import Duck from 'extensible-duck'
/* eslint-disable-next-line import/no-cycle */
import auth from '../auth'
import getCheckoutPrice from './selectors/getCheckoutPrice'

export default function createDuck({ namespace = 'gadget', store, initialState }) {
    return new Duck({
        namespace,
        store,
        initialState,
        selectors: {
            root: (state) => state,
            getCheckoutPrice: ({ state, router }) => getCheckoutPrice({ state, router }),
        },
        types: ['INITIALIZE'],
        creators: (duck) => ({
            initialize: (payload = {}) => ({ type: duck.types.INITIALIZE, ...payload }),
        }),
        reducer: (state, { type }, duck) => {
            if (type === auth.types.LOGOUT) {
                switch (duck.store) {
                    case 'loader':
                        return state
                    default:
                        return duck.initialState
                }
            }

            if (type === duck.types.INITIALIZE) {
                return duck.initialState
            }

            return state
        },
    })
}
